import moment from 'moment';
import { GetAllMonths } from './fecha';
import { ROLES_EXPATRIADOS } from '../constanst/constants';


export const AnioActual = moment().year();
export const MesActual = moment().month()+1;

export const optionsMesesSelector = ()=>{

const _meses = GetAllMonths();

return _meses.map((m,i)=>{return { value: (i+1).toString(), inputDisplay: m, disabled:false}})

}

export const optionsMesesSelectorSimple = ()=>{

    const meses = GetAllMonths();
    
    return meses.map((m,i)=>{return { value: (i+1).toString(), text: m}})
}

export const getPermisoExpatriados = (value)=>{
    switch (value) {
        case 'AD':
            return ROLES_EXPATRIADOS.ADMINISTRADOR;
            case 'ADL':
                return ROLES_EXPATRIADOS.ADMINISTRADOR_LOCAL;
                case 'CON':
                    return ROLES_EXPATRIADOS.CONSULTA;
                    default:
                        return ROLES_EXPATRIADOS.ADMINISTRADOR_GLOBAL;
    }
}

export const AniosFacturacionExpatriados = () =>{
    let _anios = [AnioActual];

    if(MesActual===1)
        _anios.push(AnioActual-1)

    return _anios;
}

export const MesesFacturacionExpatriados = (ejercicio, esADM)=>{

    let _meses = optionsMesesSelector();
    
    return _meses.map((m,i)=>{
        const _value = parseInt(m.value)
        return esADM===true ? {...m,...{disabled:false}} :((ejercicio!==undefined && ejercicio<AnioActual) ? {...m,...{disabled:_value!==12}} : 
            {...m,...{disabled:!(ejercicio===AnioActual && (_value===MesActual || _value===MesActual-1))}})
    })
}

export const MesesValidacionesExpatriados = (ejercicio)=>{

    let _meses = optionsMesesSelector();
    
    return _meses.map((m,i)=>{
        const _value = parseInt(m.value)
        return (ejercicio!==undefined && ejercicio<AnioActual) ? {...m,...{disabled:false}} : 
            {...m,...{disabled:!(ejercicio===AnioActual && (_value===MesActual || _value===MesActual-1))}}
    })
}